import 'assets/vendors/style';
import 'styles/tailwind.css';
import 'styles/wieldy.less';

import { ApolloProvider } from '@apollo/client';
import { ConnectedRouter } from 'connected-react-router';
import history from 'constants/history';
import React from 'react';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import apolloClient from 'services/graphql/config';
import { persistor, store } from 'store';

import App from './containers/App';

const NextApp: React.FC = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ApolloProvider client={apolloClient}>
        <ConnectedRouter history={history}>
          <Switch>
            <Route path='/' component={App} />
          </Switch>
        </ConnectedRouter>
      </ApolloProvider>
    </PersistGate>
  </Provider>
);

export default NextApp;
